module.exports = __webpack_public_path__ + "img/icon2.f19a031b.svg";